import React, {useEffect, useState} from 'react';
import {Card} from "react-bootstrap";
import "../../layout/styles/components/CardView.scss"
import {useNavigate} from 'react-router-dom';
import {getAuthMenus} from "../../api/apiClient";

const CardView = ({
                    propType = '',
                    propDate = '',
                    propLevel = '',
                    propText = ``,
                    propText2 = '화재발생 없음',
                    propLineBreak = false,
                    propLength,
                    propAnonAPI = false,
                  }) => {

  const navigate = useNavigate();

  useEffect(() => {
    console.log(propAnonAPI);
  }, [propAnonAPI]);

  const [faultHistoryMenuAuth, setFaultHistoryMenuAuth] = useState(1);

  useEffect(() => {
    getAuthMenus("FA00000010")
        .then((res) => {
          // console.log(res.data.data.list.length);
          if (res.data.data.list.length === 0) {
            setFaultHistoryMenuAuth(0);
          } else {
            setFaultHistoryMenuAuth(1);
          }
        });
  }, []);


  return (
      /*<Card
          // border={'light'}
          /!*className={
            propLevel == 'crit' ? 'crit-bg' :
                propLevel == 'major' ? 'major-bg' :
                    propLevel == 'minor' ? 'minor-bg' : ''
          }*!/
      >*/
      <Card
          bg={'dark'}
          key={'dark'}
          border="light"
          // text={'Dark'.toLowerCase() === 'light' ? 'dark' : 'white'}
          // style={{ width: '18rem' }}
          // className={`mb-2 ${propLevel == 'crit' ? 'crit-bg' : propLevel == 'major' ? 'major-bg' : propLevel == 'minor' ? 'minor-bg' : ''}`}
          className={`mb-2`}
          onClick={() => {
            // console.log('CardView clicked');
            if (propText && propAnonAPI === false) {
              if (faultHistoryMenuAuth) {
                navigate('/ui/fault-history', {
                  state: {
                    // propType: propType,
                    // propDate: propDate,
                    // propLevel: propLevel,
                    propText: propText,
                    // propText2: propText2,
                    // propLength: propLength
                  }
                })
              }
            }
          }}
      >
        {/*<Card.Body className={`text-center ${propLength === 1 ? 'my-5 py-5' : ''}`}>*/}
        <Card.Body className={`text-center`} role={(propText && propAnonAPI  === false) && faultHistoryMenuAuth ? `button` : ''}>
          {propText ? <div
              className={`fs-3 fw-bold 
              ${propText === "Critical" ? "text-danger" : ""}
              ${propText === "Minor" ? "text-warning" : ""}
              ${propLength === 1 ? "mt-5" : ''}
              `}
              style={{color: "rgb(254, 132, 40)"}}
              // style={propLength === 1 ? {marginBottom: '2rem', color: "rgb(254, 132, 40)"} : propLength === 2 ? {} : {color: "rgb(254, 132, 40)"}}
          >
            {propText}
          </div> : ''}

          {propDate ? <div
              // className={`fs-3 ${propLength === 2 ? 'mt-4' : propLength === 1 ? 'mt-5 mb-5' : 'mb-0'}`}
              className={`fs-3 ${propLength === 1 ? 'mt-5' : propLength >= 2 ? 'mb-0' : ''}`}
              style={propLength === 1 ? {marginBottom: '2.5rem'} : propLength === 2 ? {marginBottom: ''} : propLength >= 3 ? {marginBottom: '0.75rem'} : {}}
          >
            {propDate}
          </div> : ''}

          {propLineBreak ? <div className={"mb-1"}></div> : ' '}

          <div
              className={`fs-3 fw-bold 
              ${propLength === 2 ? '' : ''}
              ${propLevel === "crit" ? "text-danger" : ""}
              `}
              style={propLength === 1 ? {marginBottom: '2.5rem'} : propLength === 2 ? {} : {}}
          >
            {propText2}<span className={"fs-5"}> {propType == 'fault' ? '건' : ''}</span>
          </div>
        </Card.Body>
      </Card>);
};

export default CardView;